<template>
  <v-container fluid pa-0>
    <!-- Filtros -->
    <v-layout row wrap>
      <v-flex xs12>
        <v-card v-if="filtros" class="mb-4">
          <v-toolbar dense color="grey lighten-2">
            <v-toolbar-title class="title">Filtros</v-toolbar-title>
            <v-divider
              class="mx-2"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn flat icon @click="filtros = false" slot="activator">
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cancelar</span>
            </v-tooltip>
            
            <v-tooltip bottom>
              <v-btn fab dark small color="primary" icon @click="aplicaFiltros" slot="activator">
                <v-icon>done</v-icon>
              </v-btn>
              <span>Aplicar</span>
            </v-tooltip>
          </v-toolbar>
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <span class="subheading font-weight-medium">Status</span>
                <v-checkbox color="primary" v-model="args.status" label="Ativo" value="A" height="0" class="mb-0"></v-checkbox>
                <v-checkbox color="primary" v-model="args.status" label="Excluido" value="C" height="0" class="my-0"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
      <div :class="filtros ? '' : 'pos-abs-fixed'">
        <v-toolbar dense color="grey lighten-2">
          <v-toolbar-title class="title">Sqls</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-text-field prepend-inner-icon="search" clearable v-model="searchTerm"></v-text-field>
          <v-tooltip bottom>
            <v-btn
              color="primary" 
              fab 
              dark 
              small
              @click="abreModalCadastroSql"
              slot="activator"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <span>Adicionar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="aplicaFiltros">
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Atualizar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <span>Opções</span>
            <v-menu bottom left slot="activator">
              <v-btn flat icon small slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  @click="editItemSelected"
                >
                  <v-list-tile-title>
                    <v-icon small class="pr-1">edit</v-icon>
                      Alterar
                    </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="deleteItemSelected"
                >
                  <v-list-tile-title>
                    <v-icon small class="pr-1">delete</v-icon>
                    Excluir
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="filtros = !filtros">
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Filtros</span>
          </v-tooltip>
        </v-toolbar>
      </div>
    <GridSql 
      :items="sqls" 
      :searchTerm="searchTerm" 
      :loading="loading"
      @editItemSelected="editItemSelected"
    />
    <ModalCadastroSql v-model="modalCadastroSql" />
    <ModalEditCadastroSql :editSql="sqlSelected" v-model="modalSql" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSql from '@/components/sql/GridSql'
import ModalCadastroSql from '@/components/sql/ModalCadastroSql'
import ModalEditCadastroSql from '@/components/sql/ModalEditCadastroSql'
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'SqlsView',
  components: {
    GridSql,
    ModalCadastroSql,
    ModalEditCadastroSql
  },
  data: () => ({
    filtros: false,
    modalCadastroSql: false,
    modalSql: false,
    searchTerm: '',
    loading: false,
    args: {
      status: 'A'
    },
    sqlSelected: null
  }),
  computed: {
    ...mapGetters(['isAdmin', 'sqls', 'sqlsSelected']),
    msgDelete() {
      return this.sqlsSelected.length > 1 ? 
        `Tem certeza que deseja excluir: ${this.sqlsSelected.length} registros?` :
        `Tem certeza que deseja excluir: ${this.sqlsSelected[0].Descricao}?`;
    }
  },
  methods: {
    ...mapActions(['fetchSqls', 'deleteSql']),
    ...mapMutations(['showNotification', 'closeNotification']),
    abreModalCadastroSql() {
      this.modalCadastroSql = true;
    },
    abreModalSql() {
      this.modalSql = true;
      this.sqlSelected = null;
    },
    editItemSelected(payload) {
      if (payload && payload.IdSql) {
        this.sqlSelected = payload;
        this.modalSql = true;
      } else if (this.sqlsSelected.length) {
        this.sqlSelected = this.sqlsSelected[this.sqlsSelected.length - 1];
        this.modalSql = true;
      } else {
        this.showNotification({ text: "Selecione um sql para alterar.", status: 'error' });
      }
    },
    async deleteItemSelected() {
      if (this.sqlsSelected.length) {
        if (confirm(this.msgDelete)) {
          let promises = [];
          this.sqlsSelected.forEach(sql => promises.push(this.deleteSql(sql.IdSql)));

          await Promise.all(promises)
            .then(() => this.showNotification({ text: 'Operação concluída com sucesso!', status: 'success' }))
            .catch(error => this.showNotification({ text: `Ocorreu um erro ao tentar excluir o(s) sql(s): ${error}`, status: 'error' }));
        }
      } else {
        this.showNotification({ text: "Selecione pelo menos um sql para excluir.", status: 'error' });
      }
    },
    async aplicaFiltros() {
      this.loading = true;
      try {
        await this.fetchSqls(this.args);
        this.loading = false;
        this.showNotification({ text: "Lista atualizada.", status: 'success' });
      } catch (error) {
        this.loading = false;
        this.showNotification({ text: `Ocorreu um erro ao buscar os sqls: ${error}`, status: 'error' });
      }

      this.salvaConfigPesquisa();
      this.filtros = false;
    },
    // Salva no localStorage o termo pesquisado caso houver, a config de paginação da tela de pesquisa e o status
    salvaConfigPesquisa() {
      this.searchTerm ? localStorage.setItem('SqlsViewSearchTerm', this.searchTerm) : localStorage.setItem('SqlsViewSearchTerm', '');
      localStorage.setItem('statusSql', this.args.status);
    },
    // Recupera do localStorage o termo pesquisado caso houver, a config de paginação da tela de pesquisa e o status
    recuperaConfigPesquisa() {
      // Verifica se existe no localStorage o item statusSql salvo anteriormente
      if (localStorage.getItem('statusSql')) {
        this.args.status = localStorage.getItem('statusSql');
      }
      // Verifica se existe o termo pesquisado salvo anteriormente
      if (localStorage.getItem('SqlsViewSearchTerm')) {
        this.searchTerm = localStorage.getItem('SqlsViewSearchTerm');
      } else {
        this.searchTerm = '';
      }
    }
  },
  async created() {
    changePageTitle('Sqls');
    if (!this.isAdmin) {
      return this.$router.go(-1);
    }
    this.recuperaConfigPesquisa();
    await this.aplicaFiltros();
  }
}
</script>

<style scoped>
.pos-abs-fixed {
  z-index: 5;
  position: relative;
  padding-bottom: 50px;
}
.pos-abs-fixed > :first-child {
  position: fixed;
}
</style>